import { AppShell } from "./components/AppShell";
import type { PlatformRouteConfig } from "./types/platformRoutes";

import DashboardWeb from "./pages/Dashboard.web";
import SettingsWeb from "./pages/Settings.web";
import ProfileWeb from "./pages/Profile.web";
import LiabilitiesWeb from "./pages/Liabilities.web";
import IncomeWeb from "./pages/Income.web";
import ExpensesWeb from "./pages/Expenses.web";
import AssumptionsWeb from "./pages/Assumptions.web";
import OnboardingPageWeb from "./pages/OnboardingPage.web";
import { WebRedirect } from "./components/WebRedirect";

const webRoutes: PlatformRouteConfig = {
  Dashboard: DashboardWeb,
  Settings: SettingsWeb,
  Profile: ProfileWeb,
  InvestableAssets: WebRedirect,
  RealEstateAssets: WebRedirect,
  Liabilities: LiabilitiesWeb,
  Income: IncomeWeb,
  Expenses: ExpensesWeb,
  Assumptions: AssumptionsWeb,
  OnboardingPage: OnboardingPageWeb,
};

/**
 * WebApp - Desktop platform application (>= 768px)
 *
 * Desktop-specific routing where settings pages redirect to dashboard.
 * Settings are accessed via modal from Dashboard, not direct navigation.
 */
function WebApp() {
  return <AppShell routes={webRoutes} />;
}

export default WebApp;
